import { handleError } from "core/utils/HandleError";
import { handleResponse } from "core/utils/HandleResponse";
import { AuthHttpClient } from "core/utils/HttpClient";
import { chatHttpClient } from "core/utils/HttpSocketClient";

export function getTournamentPlayOff(palyoffId: string) {
  return AuthHttpClient.get(`/core/tournament/playoff/${palyoffId}`, {
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getTournamentPlayOffBattleRoyale(palyoffId: string) {
  return AuthHttpClient.get(`/core/tournament/playoff/battle-royale/${palyoffId}`, {
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getTournamentMatchChatMessages({
  limit,
  roomId,
  page,
}: {
  limit: number;
  roomId: string;
  page: number;
}) {
  return chatHttpClient
    .get(`/rooms/match/${roomId}/messages`, {
      params: { limit, page },
    })
    .then((response: any) => response.data)
    .catch(handleError);
}
